import {Webdoku} from "../models/webdoku";
import {Status} from "../models/status";
import {WebdokuDto} from "../dto/webdoku-dto";
import {StatusDto} from "../dto/status-dto";
import { PlanningJobDto } from '../dto/planning-job-dto';
import { PlanningJob } from '../models/planning-job';
import { RBConvert } from '@ldw/roesberg';

export class WebdokuFactory {
  static fromDTO(webDokuDTO: WebdokuDto): Webdoku {
    const wd = new Webdoku();
    wd.id = webDokuDTO.id;
    wd.text = webDokuDTO.text;
    wd.redliningAllowed = webDokuDTO.redliningAllowed;
    wd.copyDocumentAllowed = webDokuDTO.copyDocumentAllowed;
    wd.deleteDocumentAllowed = webDokuDTO.deleteDocumentAllowed;
    wd.hasLoopNodes = webDokuDTO.hasLoopNodes;
    wd.hasCustomNavigation = webDokuDTO.hasCustomNavigation;
    wd.isSubWebDoku = webDokuDTO.isSubWebDoku;
    wd.mainWebDokuId = webDokuDTO.mainWebDokuId;
    wd.mainWebDokuName = webDokuDTO.mainWebDokuName;
    wd.group = webDokuDTO.group;
    wd.description = webDokuDTO.description;
    wd.location = webDokuDTO.location;
    if (webDokuDTO.status != null) {
      webDokuDTO.status.forEach(dto => {
        wd.status.push(this.fromStatus(dto));
      });
    }
    if (webDokuDTO.planningJobs != null) {
      webDokuDTO.planningJobs.forEach(dto => {
        wd.planningJobs.push(this.fromPlanningJob(dto));
      });
    }
    return wd;
  }

  private static fromStatus(statusDTO: StatusDto): Status {
    const status = new Status();
    status.id = statusDTO.id;
    status.text = statusDTO.text;
    status.backColor = statusDTO.bgColor;
    status.textColor = statusDTO.txColor;
    return status;
  }

  private static fromPlanningJob(dto: PlanningJobDto):PlanningJob  {
    const job = new PlanningJob();
    job.name = dto.name;
    job.description = dto.description;
    job.status = dto.status;
    job.isActive = dto.isActive;
    job.startDate = RBConvert.utcStringToDate(dto.startDate);
    job.endDate = RBConvert.utcStringToDate(dto.endDate);
    return job;
  }
}
